var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "form-checkbox",
        class: {
          "form-checkbox--error": _vm.error,
        },
      },
      [
        _c("input", {
          staticClass: "form-checkbox__field",
          attrs: {
            type: "checkbox",
            id: _vm.uniqueId,
            name: _vm.name,
            required: _vm.required,
            disabled: _vm.disabled,
          },
          domProps: { value: _vm.value, checked: _vm.checked },
          on: { change: _vm.onChange },
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "form-checkbox__label", attrs: { for: _vm.uniqueId } },
          [
            _c("span", { staticClass: "form-checkbox__label-box" }),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "form-checkbox__label-text" },
              [
                _vm._t("default", function () {
                  return [
                    _c("span", {
                      directives: [
                        {
                          name: "sanitize",
                          rawName: "v-sanitize",
                          value: _vm.label,
                          expression: "label",
                        },
                      ],
                    }),
                  ]
                }),
              ],
              2
            ),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _vm.hint
      ? _c("span", {
          staticClass: "form-checkbox__hint | form-input-hint",
          domProps: { innerHTML: _vm._s(_vm.hint) },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.error && _vm.errorMessage
      ? _c("span", {
          staticClass: "form-checkbox__error | form-input-error",
          domProps: { innerHTML: _vm._s(_vm.errorMessage) },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.successMessage
      ? _c("span", {
          staticClass: "form-checkbox__success | form-input-success",
          domProps: { innerHTML: _vm._s(_vm.successMessage) },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }